import {
	Box,
	Button,
	IconButton,
	InputAdornment,
	TextField,
	Alert,
	Snackbar,
	Typography,
	Divider,
	useMediaQuery,
} from "@mui/material";
import { useTheme } from "@emotion/react";
import useStyle from "./styles";
import loginImg from "../../../assets/imgs/login/loginDarkmode.png";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import loginImgWhite from "../../../assets/imgs/login/loginWhitemode.png";

import {
	PrivacyTipOutlined,
	VisibilityOffOutlined,
	VisibilityOutlined,
} from "@mui/icons-material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import AccountCircle from "@mui/icons-material/AccountCircle";
import LockIcon from "@mui/icons-material/Lock";
import { checkIsPermissionCliente } from "../protectedRoute/ClientePermissionRoute";
import { resolvePrimeiraRotaCliente } from "../../../utils/permissoesCliente";
import { useSystemStatus } from "../../../services/systemStatus";
import apiCliente from "../../../services/apiCliente";

export default function Login() {
	// sistema bloqueado (SISTEM_BLOCK): o backend recusa /cliente/login com 503
	const { whatsapp: suporteWhatsapp } = useSystemStatus();
	const [showPassword, setShowPassword] = useState(false);
	const [login, setLogin] = useState("");
	const [senha, setSenha] = useState("");
	const theme = useTheme();
	const styles = useStyle(theme);
	const [snackbar, setSnackbar] = useState(null);
	const [Null, setNull] = useState(false);
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();
	const [shrink, setShrink] = useState(false);
	const [passShrink, setPassShrink] = useState(false);
	const isScreenSmall = useMediaQuery(theme.breakpoints.up("lg"));
	const hiddenButtonLogin =
		window?.config?.REACT_APP_HIDDEN_LOGIN_BUTTON ||
		process.env.REACT_APP_HIDDEN_LOGIN_BUTTON ||
		"";

	// limita o keydown no campo senha
	const [enterFlag, setEnterFlag] = useState(false);

	const url = `${
		window?.config?.REACT_APP_BASE_URL || process.env.REACT_APP_BASE_URL || ""
	}`;

	//img background
	const urlLoginImg = `${
		window?.config?.REACT_APP_LOGIN_IMG_EXTERNO ||
		process.env.REACT_APP_LOGIN_IMG_EXTERNO ||
		""
	}`;
	const logoExternoDark = `${
		window?.config?.REACT_APP_LOGO_EXTERNO_DARK ||
		process.env.REACT_APP_LOGO_EXTERNO_DARK ||
		""
	}`;
	const logoExternoLight = `${
		window?.config?.REACT_APP_LOGO_EXTERNO_LIGHT ||
		process.env.REACT_APP_LOGO_EXTERNO_LIGHT ||
		""
	}`;

	//radesociais
	const urlFacebook = `${
		window?.config?.REACT_APP_URL_FACEBOOK ||
		process.env.REACT_APP_URL_FACEBOOK ||
		""
	}`;
	const urlInstagram = `${
		window?.config?.REACT_APP_URL_INSTAGRAM ||
		process.env.REACT_APP_URL_INSTAGRAM ||
		""
	}`;
	const urlLinkedin = `${
		window?.config?.REACT_APP_URL_LINKEDIN ||
		process.env.REACT_APP_URL_LINKEDIN ||
		""
	}`;

	// Redireciona o usuário já autenticado (dados de "userCliente"/"perfilCliente")
	const entrarNoSistema = async (userData, perfil) => {
		const usuarioCliente = userData?.usuarioCliente;
		if (
			usuarioCliente?.status == true &&
			userData?.perfilAlreadyExists === true &&
			usuarioCliente?.cliente?.status === 0 &&
			perfil?.telefone
		) {
			// O usuário pode não ter acesso à Home: entra na primeira tela
			// liberada pela permissão dele, em vez de cair no acesso negado
			const userPermission = await checkIsPermissionCliente();
			navigate(
				await resolvePrimeiraRotaCliente(
					usuarioCliente,
					userPermission?.isAdmin,
				),
			);
		} else if (
			usuarioCliente?.status == true &&
			usuarioCliente?.cliente?.status === 0 &&
			(userData?.perfilAlreadyExists === false || !perfil?.telefone)
		) {
			navigate("/cliente/cadastro");
		} else if (
			usuarioCliente?.status == false &&
			userData?.perfilAlreadyExists === true
		) {
			setSnackbar({
				children: `Usuário desativado`,
				severity: "error",
			});
		} else if (
			usuarioCliente?.status == true &&
			usuarioCliente?.cliente?.status === 1
		) {
			setSnackbar({
				children: `Cliente desativado`,
				severity: "error",
			});
		}
	};

	// Login automático: se já existe token salvo e ele ainda é válido, entra
	// direto em vez de pedir login de novo. Após o logout o localStorage está
	// vazio, então nada acontece. Com "user" presente é o interno em modo
	// espelho, que não deve virar sessão de cliente.
	useEffect(() => {
		let userData = null;
		try {
			userData = JSON.parse(localStorage.getItem("userCliente"));
		} catch (error) {}
		if (!userData?.token || localStorage.getItem("user")) return;

		setLoading(true);
		apiCliente
			.get("/cliente/authenticationToken")
			.then(() =>
				entrarNoSistema(
					userData,
					JSON.parse(localStorage.getItem("perfilCliente")),
				),
			)
			.catch(() => {})
			.finally(() => setLoading(false));
	}, []);

	const handleLogin = async () => {
		if (!login || !senha) {
			setNull(true);
			return;
		}
		setLoading(!login || !senha);
		try {
			const response = await axios.post(
				`${url}/cliente/login`,
				{ login, senha },
				{ withCredentials: false },
			);

			if (response?.data?.token) {
				const { perfil, logs, ...userData } = response.data;
				localStorage.clear();
				if (
					response.data.usuarioCliente?.status &&
					response.data.usuarioCliente?.cliente?.status === 0
				) {
					localStorage.setItem("userCliente", JSON.stringify(userData));
					if (perfil)
						localStorage.setItem("perfilCliente", JSON.stringify(perfil));
					localStorage.setItem("logs", JSON.stringify(logs));
				}

				await entrarNoSistema(userData, perfil);
			} else {
				localStorage.clear();
				setSnackbar({
					children: `Erro: senha ou login incorreto`,
					severity: "error",
				});
			}
		} catch (error) {
			if (error?.response?.status === 503) {
				setSnackbar({
					children: `Sistema indisponível. Entre em contato com o suporte.`,
					severity: "warning",
					duracao: 10000,
					
				});
			} else if (error?.response?.status === 401) {
				setSnackbar({
					children: `Erro: senha ou login incorreto`,
					severity: "error",
				});
			} else if (error?.response?.status === 429) {
				const dataError = isValidJSON(error?.response?.data?.error)
					? JSON.parse(error?.response?.data?.error)
					: "";
				setSnackbar({
					children: `Erro: Muitas tentativas incorretas. Por favor aguarde ${
						dataError?.waitingTime || 5
					} minutos`,
					severity: "error",
				});
			} else {
				setSnackbar({
					children: `Erro: Falha ao tentar se conectar ao Servidor`,
					severity: "error",
				});
			}
			console.error(error);
		}
		setLoading(false);
	};

	const isValidJSON = (str) => {
		try {
			JSON.parse(str);
			return true;
		} catch (e) {
			return false;
		}
	};

	return (
		<Box sx={styles.container}>
			<Box sx={styles.form}>
				<Box
					sx={{
						display: "flex",
						justifyContent: "flex-end",
						width: "95%",
						mt: 2,
					}}
				>
					{!hiddenButtonLogin && (
						<Button
							variant="outlined"
							onClick={() => {
								navigate("/interno/login");
							}}
						>
							INTERNO
						</Button>
					)}
				</Box>
				<Box sx={styles.body}>
					<Box sx={styles.content}>
						<Box sx={styles.logo}>
							<Box sx={styles.boxLogo}>
								<img
									src={
										theme.palette.mode == "dark"
											? logoExternoDark
											: logoExternoLight
									}
									style={styles.img}
									alt="logo-empresa"
								/>
							</Box>
						</Box>

						<Box sx={styles.containerSubtitle}>
							<Typography sx={{ fontSize: "26px", fontWeight: 400 }}>
								Faça login na sua conta
							</Typography>
							<Box sx={{ display: "flex", gap: 1 }}>
								<Typography
									sx={{ fontSize: "16px", fontWeight: 400, color: "grey" }}
								>
									Novo por aqui?
								</Typography>
								<Typography
									sx={{
										fontSize: "16px",
										fontWeight: 500,
										color: theme.palette.tertiary.main,
									}}
								>
									Cadastre-se ou Contate-nos
								</Typography>
							</Box>
						</Box>
						<TextField
							id="login"
							variant="filled"
							label="Login"
							size="medium"
							sx={styles.textfield}
							error={!login && Null}
							onChange={(event) => {
								setLogin(event.target.value);
							}}
							onKeyDown={(event) => {
								if (event.key === "Enter") {
									event.preventDefault();
									document.getElementById("password").focus();
								}
							}}
						/>

						<TextField
							id="password"
							variant="filled"
							label="Senha"
							size="medium"
							type={showPassword ? "text" : "password"}
							sx={styles.textfield}
							autoComplete="off"
							error={!senha && Null}
							onKeyDown={(event) => {
								if (event.key === "Enter" && !enterFlag) {
									setEnterFlag(true);
									handleLogin();
								}
							}}
							onKeyUp={(event) => {
								setEnterFlag(false);
							}}
							onChange={(event) => {
								setSenha(event.target.value);
							}}
							InputProps={{
								endAdornment: (
									<InputAdornment position="end">
										<IconButton
											color="disabled"
											aria-label="toggle password visibility"
											onClick={() => setShowPassword((show) => !show)}
											onMouseDown={(event) => {
												event.preventDefault();
											}}
										>
											{showPassword ? (
												<VisibilityOffOutlined />
											) : (
												<VisibilityOutlined />
											)}
										</IconButton>
									</InputAdornment>
								),
							}}
						/>
						<Box sx={styles.boxRecover}>
							<Button
								sx={styles.buttonRecover}
								onClick={() => {
									navigate("/cliente/redefinirSenha");
								}}
							>
								Esqueceu a senha ?
							</Button>
						</Box>
						<Button
							variant="contained"
							color="primary"
							sx={styles.button}
							onClick={handleLogin}
							disabled={loading}
						>
							Entrar
						</Button>
					</Box>
				</Box>

				<Divider sx={{ mt: 8 }} variant="fullWidth">
					<Typography sx={{ color: "grey" }}>Redes Sociais</Typography>
				</Divider>
				<Box sx={styles.body}>
					<Box
						sx={{
							...styles.content,
							flexDirection: "row",
							alignItems: "center",
							justifyContent: "center",
						}}
					>
						<IconButton
							variant="contained"
							size="large"
							disabled={!urlFacebook}
							onClick={() => {
								window.open(`${urlFacebook}`, "_blank");
							}}
						>
							<FacebookOutlinedIcon sx={{ width: 30, height: 30 }} />
						</IconButton>
						<IconButton
							variant="contained"
							size="large"
							disabled={!urlInstagram}
							onClick={() => {
								window.open(`${urlInstagram}`, "_blank");
							}}
						>
							<InstagramIcon
								sx={{
									width: 30,
									height: 30,
								}}
							/>
						</IconButton>
						<IconButton
							variant="contained"
							size="large"
							disabled={!urlLinkedin}
							onClick={() => {
								window.open(`${urlLinkedin}`, "_blank");
							}}
						>
							<LinkedInIcon sx={{ width: 30, height: 30 }} />
						</IconButton>
					</Box>
				</Box>
			</Box>

			<Box>
				<Box
					component={"img"}
					src={urlLoginImg}
					alt="login-image"
					sx={{
						...styles.boxImg,
						width: "60vw",
						backgroundSize: "cover",
						backgroundPosition: "center",
						"@media (min-width: 2200px)": {
							backgroundSize: "cover",
						},
						"@media(max-width: 1200px)": {
							display: "none",
						},
					}}
				/>
			</Box>

			{!!snackbar && (
				<Snackbar
					open
					onClose={() => setSnackbar(null)}
					autoHideDuration={snackbar.duracao || 3000}
					anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
				>
					{/* duracao não é prop do Alert */}
					<Alert
						severity={snackbar.severity}
						action={snackbar.action}
						onClose={() => setSnackbar(null)}
					>
						{snackbar.children}
					</Alert>
				</Snackbar>
			)}
		</Box>
	);
}
